import React from 'react';
import { ICustomComponentProps, IRoleConnectionDetail } from '../../../api/blueprints/blueprint-details.types';

const BlueprintDetailsCustomRoleConnections = ({
    values,
}: Partial<ICustomComponentProps>) => {
    return (

        <div className='blueprint-details--settings-item'>
            {
                (values as IRoleConnectionDetail[]).map(({ role, name }) => {
                    return (
                        <div key={role} className='blueprint-list-item wrap-word'>
                            {role}: {name}
                        </div>
                    );
                })
            }
        </div>
    );
};

export default BlueprintDetailsCustomRoleConnections;
